import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let EngineersIcon = (props) => {
  props = Object.assign({viewBox: '0 0 70 70'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <g>
          <path d="M54.1,61.5H15.9l-0.1-1.2c0-0.3-0.1-1.3-0.1-1.4c0-4.6,1.7-9.1,4.7-12.6c2.6-3,5.9-5,9.7-6l0.7,2.6
			c-3.3,0.8-6.2,2.6-8.4,5.2c-2.6,3-4.1,6.9-4.1,10.8h33.1c0-3.8-1.2-7.3-3.6-10.3c-2.2-2.7-5.1-4.7-8.5-5.6l0.7-2.6
			c3.9,1.1,7.3,3.4,9.8,6.5c2.7,3.4,4.2,7.6,4.2,12c0,0.2,0,1.1-0.1,1.4L54.1,61.5z"/>
          <path d="M35,36.2c-5.7,0-10.3-4.6-10.3-10.3S29.3,15.6,35,15.6s10.3,4.6,10.3,10.3S40.7,36.2,35,36.2z M35,18.3
			c-4.2,0-7.6,3.4-7.6,7.6s3.4,7.6,7.6,7.6s7.6-3.4,7.6-7.6S39.2,18.3,35,18.3z"/>
          <path d="M39.5,43c-2.9-0.8-5.7-0.8-8.6-0.1l-0.7-2.6c3.3-0.9,6.6-0.8,10,0.1L39.5,43z"/>
        </g>
        <rect x="29.6" y="58.8" width="10.7" height="2.7"/>
        <path d="M35,51.4"/>
        <path d="M35,51.4"/>
        <g>
          <path d="M20.2,32.2"/>
          <path d="M47.7,18.4C45,14,40.2,11.2,35,11.2S25,14,22.3,18.5L20,17.1c3.1-5.3,8.9-8.6,15-8.6s11.9,3.3,15,8.6L47.7,18.4z"/>
          <path d="M49.8,32.2"/>
          <path d="M18.9,33.6c-4.9,0-8.8-4-8.8-8.8c0-4.9,4-8.8,8.8-8.8c0.9,0,1.7,0.2,2.7,0.5l1.6,0.5l-0.8,1.4c-1.3,2.3-2,4.8-2,7.4
			c0,2,0.4,3.9,1.2,5.8l0.7,1.5l-1.7,0.3C19.9,33.6,19.4,33.6,18.9,33.6z M18.9,18.7c-3.4,0-6.1,2.7-6.1,6.1c0,3.2,2.5,5.8,5.6,6.1
			c-0.5-1.6-0.7-3.3-0.7-5c0-2.5,0.5-4.9,1.6-7.2C19.1,18.7,19,18.7,18.9,18.7z"/>
          <path d="M19,32.7c-0.9-2.2-1.4-4.4-1.4-6.8c0-3.1,0.8-6.1,2.4-8.8l2.3,1.4c-1.3,2.3-2,4.8-2,7.4c0,2,0.4,3.9,1.2,5.8L19,32.7z"/>
          <path d="M51.1,33.6c-0.5,0-1,0-1.6-0.2l-1.7-0.3l0.7-1.5c0.8-1.8,1.2-3.8,1.2-5.8c0-2.6-0.7-5.2-2-7.4L46.8,17l1.6-0.5
			c1-0.3,1.8-0.5,2.7-0.5c4.9,0,8.8,4,8.8,8.8C59.9,29.7,56,33.6,51.1,33.6z M50.8,18.7c1,2.3,1.6,4.7,1.6,7.2c0,1.7-0.3,3.4-0.7,5
			c3.1-0.3,5.6-2.9,5.6-6.1C57.2,21.4,54.3,18.5,50.8,18.7z"/>
          <path d="M51,32.7l-2.5-1.1c0.8-1.8,1.2-3.8,1.2-5.8c0-2.6-0.7-5.2-2-7.4L50,17c1.6,2.7,2.4,5.7,2.4,8.8
			C52.4,28.2,51.9,30.5,51,32.7z"/>
        </g>
      </g>
    </SvgIcon>
  );
};

EngineersIcon.displayName = 'EngineersIcon';
EngineersIcon.muiName = 'SvgIcon';

export default EngineersIcon;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/icons/Engineers.Icon.js